import { render, staticRenderFns } from "./TruckEditorModal.vue?vue&type=template&id=0b9cf75d&scoped=true"
import script from "./TruckEditorModal.vue?vue&type=script&lang=js"
export * from "./TruckEditorModal.vue?vue&type=script&lang=js"
import style0 from "./TruckEditorModal.vue?vue&type=style&index=0&id=0b9cf75d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9cf75d",
  null
  
)

export default component.exports